import React, { FC } from "react";
import { companyInfoFields } from "../clientAllFields";
import { Box, Grid, Typography } from "@mui/material";
import FormField from "../../../../components/common/FormField";
import ImageUploader from "../../../../components/common/imageUploader/ImageUploader";
import uploadImg from "../../../../assets/images/uploadImg.png";
import { useDispatch } from "react-redux";
import { getCheckUniqueCompanyNameAction, getCheckUniqueEmailAction, getCheckUniqueVatAction, setCheckUniqueCompanyNameAction, setCheckUniqueVatAction, setNewClientLocal } from "../../../../store/reducers/adminClientsSlice";
import { useSelector } from "react-redux";

interface ManageCompanyInfoProps {
  selectClient: any; // Adjust type as per your requirement
  companyProfileError: any;
  formData?: any;
  setFormData?: any;
  checkValidator?: any;
  resetValidator?: any;
  action?: any;
}
const CompanyInfoForm: FC<ManageCompanyInfoProps> = ({
  selectClient,
  companyProfileError,
  formData,
  setFormData,
  checkValidator,
  resetValidator,
  action
}) => {
  const handleImageUpload = (image: string | null) => {
    console.log("Uploaded image:", image);
  };
  const dispatch = useDispatch();
  const { newClientLocal, isUniqueCompanyNameError, isUniqueVatError, editClientOriginalData } = useSelector((state: any) => state?.adminClients);

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;

    let transformedValue: string | number = value;

   // Check specific fields to convert to number
  // if (id === "vatPercent" ) {
  //   // Check if value is numeric (allow empty input as well)
  //   if (value === '') {
  //     transformedValue = ''; // Handle empty input
  //   } else if (/^\d*$/.test(value)) {
  //     transformedValue = parseInt(value, 10); // Parse to integer
  //   } else {
  //     transformedValue = ''; // Handle non-numeric input as needed
  //   }
  // }

// Dispatch only if the value is not empty or undefined
// if (transformedValue !== '' && transformedValue !== undefined) {
    dispatch(
      setNewClientLocal({
        // ...newClientLocal,
        companyProfile: {
          ...newClientLocal?.companyProfile,
          [id]: transformedValue,
        },
        ...id === "address" && newClientLocal?.financialInformation?.isSameWithCompanyAddress && {
          financialInformation: {
            ...newClientLocal?.financialInformation,
            "invoiceAddress": transformedValue,
          },
        }
      })
    );

    setFormData((prevValues: any) => ({ ...prevValues, [id]: transformedValue }));
    resetValidator(event.target.id);
    if(id==="companyName"){
      dispatch(setCheckUniqueCompanyNameAction(false));
    } else if(id==="vatRegNo" && value !== ''){
      dispatch(setCheckUniqueVatAction(false));
    }
  // }
  };

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    checkValidator(e.target.id);
    if(id==="companyName" && value.trim() !== ''){
      if(action === 'edit'){
         if(editClientOriginalData?.company_name !== newClientLocal?.companyProfile?.companyName) {
           dispatch(getCheckUniqueCompanyNameAction(value));
         }
      } else {
        dispatch(getCheckUniqueCompanyNameAction(value));
      }
    } else if(id==="vatRegNo" && value.trim() !== ''){
      if(action === 'edit'){
        if(editClientOriginalData?.vat_reg_no !== newClientLocal?.companyProfile?.vatRegNo) {
          dispatch(getCheckUniqueVatAction(value));
        }
      } else {
        dispatch(getCheckUniqueVatAction(value));
      }
    }
  };

  const onDateChangeAction = (event: any) => {
    const { id, value } = event.target;

    dispatch(
      setNewClientLocal({
        companyProfile: {
          ...newClientLocal?.companyProfile,
          [id]: value,
        },
      })
    );

    setFormData((prevValues: any) => ({ ...prevValues, [id]: value }));
  };
 
  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center" mr={4}>
        <ImageUploader
          defaultImage={uploadImg}
          onImageUpload={handleImageUpload}
          width={60}
          height={60}
        />
        <Typography
          sx={{ color: "#333333", fontWeight: 600 }}
          mb={1}
          variant="h6"
        >
          Logo
        </Typography>
      </Box>
      {companyInfoFields?.map((field, i) => {
        return (
          !selectClient && (
            <Grid container spacing={2} key={i}>
              <FormField
                onPaste={(e)=>e.preventDefault()}
                onKeyDown={(event:any) => {
                  console.log('event log-',event, event.target.value + event.key)
                  if(
                    event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 37 ||
                    event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40 ||
                    event.keyCode === 18 || event.keyCode === 17 ||
                    event.ctrlKey
                  ) return event  
                  if(field?.patternAllowed && (!field?.patternAllowed.test(event.key))){
                    event.preventDefault();
                  } else if(field?.patternAllowed && (!field?.patternAllowed.test(event.target.value + event.key))){
                    event.preventDefault();
                  }
                }}
                {...{
                  ...field,
                  value: newClientLocal?.companyProfile ? newClientLocal?.companyProfile[field?.id] : '',
                  ...{
                    variant: "outlined", // Adding this variant prop
                    onChange: onChangeAction,
                    onBlur: onBlurAction,
                    InputProps: {
                      // ...field?.max && {min: 0, max: field?.max},
                      ...field?.inputProps && field?.inputProps,
                      sx:
                        field?.type === "text"
                          ? { height: "36px" }
                          : { padding: "10px 4px", height: "36px" },
                    },
                    error:
                      (field?.id === 'companyName' && isUniqueCompanyNameError) ? true :
                      (field?.id === 'vatRegNo' && isUniqueVatError) ? true :
                      companyProfileError && companyProfileError[field?.id],
                    selectedValues: formData[field?.id]
                  },
                }}
              />
            </Grid>
            // </Grid>
          )
        );
      })}
    </>
  );
};
export default CompanyInfoForm;
